import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import type { ListingProduct } from 'src/generated/graphql';

interface StandardProductDetailsProps {
  product: ListingProduct;
}

export const StandardProductDetails = (props: StandardProductDetailsProps) => (
  <Card data={{ testid: 'standard-product-details' }}>
    <Stack space="large">
      <Heading level="4" component="h3">
        Purchase Standard ad
      </Heading>

      <List type="icon" icon={<IconTick tone="positive" />}>
        {[
          "Appear on Australia's #1 business marketplace",
          'List until your business sells',
          'Connect with interested buyers',
          'Photo included in search results',
          'Appear higher in search results',
          'Included in daily buyer recommendation emails',
        ].map((feature) => (
          <Text key={feature}>{feature}</Text>
        ))}
      </List>

      <Text size="large" data={{ testid: 'standard-product-details-price' }}>
        ${props.product.cost / 100} + GST
      </Text>
    </Stack>
  </Card>
);
